import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { OrderCreateOrderTemplateComponent as OriginalComponent } from '../../shared/order-create-order-template/order-create-order-template.component';

@Component({
  selector: 'ish-lazy-order-create-order-template',
  templateUrl: './lazy-order-create-order-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyOrderCreateOrderTemplateComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/order-templates/shared/order-create-order-template/order-create-order-template.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() lineItems: OriginalComponent['lineItems'];

  @Input() cssClass: OriginalComponent['cssClass'];


  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('orderTemplates').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../order-templates.module`).then(m => m.OrderTemplatesModule);

    const { OrderCreateOrderTemplateComponent: originalComponent } = await import('../../shared/order-create-order-template/order-create-order-template.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.lineItems = this.lineItems;
      
        this.component.instance.cssClass = this.cssClass;
      

      
    }
  }

}
